import { Subscription } from "rxjs";
import Logger from '../../js/lib/logger';
import { boardMode$, trayData$ } from "../lib/state";
import { TrayData } from "../lib/types";
import { SVG } from '@svgdotjs/svg.js'
import { INNER_RECT_OFFSET_PX, Measurement } from "../lib/constants";

class SvgGrid extends HTMLElement {
  #NAME = 'SvgGrid';
  #subs: Subscription[] = [];
  #trayData: TrayData = {
    width: 0,
    height: 0,
    depth: 0,
    inserts: [],
    subtotal: 0
  };
  #svg: SVGElement | null = null;
  #width: number = 0;
  #height: number = 0;

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
  }

  connectedCallback(): void {
    Logger.info(`${this.#NAME} > connectedCallback`);
    this.#subs = [
      trayData$.subscribe(dta => {
        this.#trayData = dta;
        this.#build();
      }),
      boardMode$.subscribe(val => this.dataset.mode = val),
    ]
  }

  disconnectedCallback(): void {
    this.#subs.forEach(sub => sub.unsubscribe());
  }

  #build() {
    const w = this.#trayData.width * Measurement.UNIT_PX - Measurement.SEP_WIDTH_PX;
    const h = this.#trayData.depth * Measurement.UNIT_PX - Measurement.SEP_WIDTH_PX;

    if (w !== this.#width || h !== this.#height) {
      Logger.info(`${this.#NAME} > #build`);
      if (this.#svg) this.#svg.remove();
      this.#width = w;
      this.#height = h;
      const numVert = Math.round((this.#trayData.width - Measurement.SEP_WIDTH) / Measurement.UNIT_FRACTION_DISPLAYED);
      const numHorz = Math.round((this.#trayData.depth - Measurement.SEP_WIDTH) / Measurement.UNIT_FRACTION_DISPLAYED);
      //
      const draw = SVG().addTo(this).attr({ id: 'svg-grid', viewBox: `-11 -11 ${w + 22} ${h + 22}` });
      draw.rect(this.#trayData.width * Measurement.UNIT_PX, this.#trayData.depth * Measurement.UNIT_PX)
          .attr({ class: 'svg-grid__border', x: -INNER_RECT_OFFSET_PX, y: -INNER_RECT_OFFSET_PX });
      draw.rect(w, h).attr({ class: 'svg-grid__bg' });
      //
      let x1: number;
      let y1: number;
      let x2: number;
      let y2: number;
      let remainder: number;

      for (let i = 1; i < numVert; i++) {
        x1 = x2 = i * Measurement.UNIT_FRACTION_DISPLAYED_PX;
        y1 = 0;
        y2 = h;
        remainder = i % Measurement.NUM_FRACTIONS_DISPLAYED;
        draw.line(x1, y1, x2, y2).attr({ class: remainder ? 'svg-grid__line--fraction' : 'svg-grid__line--unit' });
      }

      for (let i = 1; i < numHorz; i++) {
        x1 = 0
        x2 = w;
        y1 = y2 = i * Measurement.UNIT_FRACTION_DISPLAYED_PX;
        remainder = i % Measurement.NUM_FRACTIONS_DISPLAYED;
        draw.line(x1, y1, x2, y2).attr({ class: remainder ? 'svg-grid__line--fraction' : 'svg-grid__line--unit' });
      }

      this.#svg = this.querySelector('svg');
    }
  }
  
}

customElements.define('svg-grid', SvgGrid);